import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';
import CheckboxGroup from '../../input/CheckBoxGroup';
import Button from '../../Button';
import './TableFilterCheckBoxGroup.scss';

const TableFilterCheckBoxGroup = (props) => {
  const { className, list, confirm, option, initialOption, onFilter } = props;

  const [value, setValue] = useState(initialOption);

  useEffect(() => {
    setValue(option);
  }, [option]);

  const onChange = useCallback((value) => {
    setValue(value);
  }, []);

  if (!list) return null;

  const onSearch = (value) => {
    confirm();
    onFilter(value);
  };

  return (
    <div className={cx('table-filter-check-box-group-wrap', className)}>
      <CheckboxGroup list={list} value={value} onChange={(value) => onChange(value)} />

      <Button color="primary" text="검색" onClick={() => onSearch(value)} />

      {initialOption ? (
        <Button
          color="light"
          text="초기화"
          onClick={() => {
            onSearch(initialOption);
            setValue(initialOption);
          }}
        />
      ) : undefined}
    </div>
  );
};

export default TableFilterCheckBoxGroup;
